<!-- eslint-disable max-len -->
<div role="img" class="svg-icon svg-icon-default">
  <img class="icon-img" src="https://puui.qpic.cn/iwan_cloud/1/8b9b53ea178f03c86dabc58053053ce9" alt="" />
</div>

<style lang="scss">
  .svg-icon-default {
    height: 160px;
    width: 160px;
    .icon-img {
      width: 100%;
      overflow: hidden;
    }
  }
</style>
